/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Email } from '../models/Email';
import type { GiftLevelModel } from '../models/GiftLevelModel';
import type { Gsoa_Customer_UpdateMyProfilePreferencies } from '../models/Gsoa_Customer_UpdateMyProfilePreferencies';
import type { Gsoa_CustomerProfile_ConfirmEmailQueryParams } from '../models/Gsoa_CustomerProfile_ConfirmEmailQueryParams';
import type { Gsoa_CustomerProfile_CRMGCustomer } from '../models/Gsoa_CustomerProfile_CRMGCustomer';
import type { Gsoa_CustomerProfile_CustomerUpdateParams } from '../models/Gsoa_CustomerProfile_CustomerUpdateParams';
import type { Gsoa_CustomerProfile_LegacyClubLevelModel } from '../models/Gsoa_CustomerProfile_LegacyClubLevelModel';
import type { Gsoa_CustomerProfile_NewPasswordBodyParams } from '../models/Gsoa_CustomerProfile_NewPasswordBodyParams';
import type { Gsoa_CustomerProfile_RegistrationBodyParams } from '../models/Gsoa_CustomerProfile_RegistrationBodyParams';
import type { Gsoa_CustomerProfile_StopMemberShipBodyParams } from '../models/Gsoa_CustomerProfile_StopMemberShipBodyParams';
import type { Password } from '../models/Password';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class GsoaCustomerService {
    /**
     * @returns void
     * @throws ApiError
     */
    public static getApiVGsoaCustomerIsAlive({
        apiVersion = 1,
    }: {
        apiVersion?: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/customer/isAlive',
            path: {
                'apiVersion': apiVersion,
            },
        });
    }
    /**
     * Validates contact information for insertion into database.
     * @returns any Contact validation was successful. Contact does not exist and can be created.
     * @throws ApiError
     */
    public static checkContactAvailable({
        apiVersion = 1,
        email,
        phoneNumber,
    }: {
        apiVersion?: number,
        /**
         * Email address to validate against CRM database.
         */
        email?: string,
        /**
         * Phone address to validate against CRM database.
         */
        phoneNumber?: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/customer/profiles/checkContactAvailable',
            path: {
                'apiVersion': apiVersion,
            },
            query: {
                'email': email,
                'phoneNumber': phoneNumber,
            },
            errors: {
                400: `Validation error.`,
                401: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Returns a list of all currently active club levels.
     * @returns Gsoa_CustomerProfile_LegacyClubLevelModel Active club levels were found.
     * @throws ApiError
     */
    public static getClubLevelList({
        apiVersion = 1,
    }: {
        apiVersion?: number,
    }): CancelablePromise<Array<Gsoa_CustomerProfile_LegacyClubLevelModel>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/customer/profiles/clubLevelList',
            path: {
                'apiVersion': apiVersion,
            },
            errors: {
                400: `Validation error.`,
                401: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Creates a new email confirmation or finishes a customer registration.
     * @returns void
     * @throws ApiError
     */
    public static confirmEmail({
        apiVersion = 1,
        requestBody,
    }: {
        apiVersion?: number,
        /**
         * Confirm email parameters.
         */
        requestBody?: Gsoa_CustomerProfile_ConfirmEmailQueryParams,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v{apiVersion}/gsoa/customer/profiles/confirmEmail',
            path: {
                'apiVersion': apiVersion,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Returns the customer profile of the currently logged-in customer.
     * @returns Gsoa_CustomerProfile_CRMGCustomer Customer profile was found.
     * @throws ApiError
     */
    public static getMyProfile({
        apiVersion = 1,
    }: {
        apiVersion?: number,
    }): CancelablePromise<Gsoa_CustomerProfile_CRMGCustomer> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/customer/profiles/me',
            path: {
                'apiVersion': apiVersion,
            },
            errors: {
                400: `Validation error.`,
                401: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Updates the customer profile of the currently logged-in customer and returns the modified customer profile.
     * @returns Gsoa_CustomerProfile_CRMGCustomer Customer profile was found and successfully modified.
     * @throws ApiError
     */
    public static updateMyProfile({
        apiVersion = 1,
        requestBody,
    }: {
        apiVersion?: number,
        /**
         * The entire set of client profile data replacing the original data.
         */
        requestBody?: Gsoa_CustomerProfile_CustomerUpdateParams,
    }): CancelablePromise<Gsoa_CustomerProfile_CRMGCustomer> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v{apiVersion}/gsoa/customer/profiles/me',
            path: {
                'apiVersion': apiVersion,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Returns authentication status and customer profile if authenticated.
     * Checks if the current session is authenticated. If yes, returns the customer profile from the /profiles/me endpoint. Uses session cookie or X-Session-Id header for authentication. Token refresh is handled automatically by middleware.
     *
     * @returns any Authentication status (with profile if authenticated).
     * @throws ApiError
     */
    public static getAuthStatus({
        apiVersion = 1,
    }: {
        apiVersion?: number,
    }): CancelablePromise<{
        authenticated: boolean;
        profile?: Gsoa_CustomerProfile_CRMGCustomer | null;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/customer/profiles/me/auth-status',
            path: {
                'apiVersion': apiVersion,
            },
            errors: {
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Changes currently logged-in customer's password.
     * @returns void
     * @throws ApiError
     */
    public static changePassword({
        requestBody,
        apiVersion = 1,
    }: {
        requestBody: {
            oldPassword: Password;
            newPassword: Password;
        },
        apiVersion?: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v{apiVersion}/gsoa/customer/profiles/me/changePassword',
            path: {
                'apiVersion': apiVersion,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Updates the preference settings for logged-in customer.
     * @returns any Request has been sent.
     * @throws ApiError
     */
    public static updateMyProfilePreferencies({
        apiVersion = 1,
        requestBody,
    }: {
        apiVersion?: number,
        /**
         * Request parameters.
         */
        requestBody?: Gsoa_Customer_UpdateMyProfilePreferencies,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v{apiVersion}/gsoa/customer/profiles/me/preferencies',
            path: {
                'apiVersion': apiVersion,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Allows customer to end his membership in CRM.
     * @returns void
     * @throws ApiError
     */
    public static stopMembership({
        apiVersion = 1,
        requestBody,
    }: {
        apiVersion?: number,
        requestBody?: Gsoa_CustomerProfile_StopMemberShipBodyParams,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v{apiVersion}/gsoa/customer/profiles/me/stopMembership',
            path: {
                'apiVersion': apiVersion,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Creates a new customer registration in CRMG.
     * @returns number Customer was succesfuly created.
     * @throws ApiError
     */
    public static createNewProfile({
        apiVersion = 1,
        requestBody,
    }: {
        apiVersion?: number,
        /**
         * Registration input paramaters.
         */
        requestBody?: Gsoa_CustomerProfile_RegistrationBodyParams,
    }): CancelablePromise<number> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v{apiVersion}/gsoa/customer/profiles/new',
            path: {
                'apiVersion': apiVersion,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `An error occurred.`,
                403: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Resets a customer's password in case it is forgot.
     * @returns void
     * @throws ApiError
     */
    public static resetPassword({
        apiVersion = 1,
        requestBody,
    }: {
        apiVersion?: number,
        requestBody?: {
            email: Email;
        },
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v{apiVersion}/gsoa/customer/profiles/passwordReset',
            path: {
                'apiVersion': apiVersion,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Performs actual password change for a customer.
     * @returns any Password change was successful.
     * @throws ApiError
     */
    public static newPassword({
        apiVersion = 1,
        requestBody,
    }: {
        apiVersion?: number,
        /**
         * New password body parameters.
         */
        requestBody?: Gsoa_CustomerProfile_NewPasswordBodyParams,
    }): CancelablePromise<{
        /**
         * if email is null, its not possible to get email from customerID
         */
        email?: string | null;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v{apiVersion}/gsoa/customer/profiles/newPassword',
            path: {
                'apiVersion': apiVersion,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `An error occurred.`,
                403: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Resends to customer email with link to complete registration.
     * @returns any Registration email was successfuly sent again.
     * @throws ApiError
     */
    public static resendRegistrationEmail({
        apiVersion = 1,
        requestBody,
    }: {
        apiVersion?: number,
        requestBody?: {
            customerLogin: Email;
        },
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v{apiVersion}/gsoa/customer/profiles/resendRegEmail',
            path: {
                'apiVersion': apiVersion,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `An error occurred.`,
                404: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
    /**
     * Returns an enumerator result of all gift levels.
     * @returns GiftLevelModel Success
     * @returns any Enumerator returned.
     * @throws ApiError
     */
    public static getAllGiftLevels({
        apiVersion = 1,
    }: {
        apiVersion?: number,
    }): CancelablePromise<Array<GiftLevelModel> | any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v{apiVersion}/gsoa/customer/pointGiftLevels',
            path: {
                'apiVersion': apiVersion,
            },
            errors: {
                304: `Not Modified`,
                400: `Request validation error.`,
                500: `Internal server error.`,
            },
        });
    }
}
